import script from "./case.vue?vue&type=script&setup=true&lang=js"
export * from "./case.vue?vue&type=script&setup=true&lang=js"

import "./case.vue?vue&type=style&index=0&id=1aa3f4b2&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\刘正希\\Desktop\\知谦\\zq\\webside\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1aa3f4b2"]])

export default __exports__